var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChurch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 258,
    viewBox: "0 0 240 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M229.948 238.422V141.911L169.817 119.817V80.9785L123.863 35.8297V20.195H134.162V12.4693H123.863V0.878906H116.137V12.4693H105.838V20.195H116.137V35.8292L70.1828 80.978V119.817L10.0514 141.911V238.422H0V257.119H240V238.422H229.948ZM169.817 128.048L222.222 147.303V152.84L169.817 133.586V128.048ZM169.817 141.817L222.222 161.072V238.422H169.817V141.817ZM77.9085 84.219L120 42.8653L162.091 84.219V91.057L120 49.7032L77.9085 91.057V84.219ZM119.999 161.839C101.573 161.839 86.5827 176.829 86.5827 195.255V238.422H77.908V116.979V101.887L119.999 60.5338L162.091 101.887V116.979V238.422H153.416V195.255C153.416 176.83 138.426 161.839 119.999 161.839ZM145.691 195.256V238.423H123.863V169.856C136.202 171.725 145.691 182.403 145.691 195.256ZM116.137 169.855V238.422H94.3089V195.255C94.3089 182.402 103.797 171.725 116.137 169.855ZM17.7772 147.303L70.1828 128.048V133.585L17.7772 152.84V147.303ZM17.7772 161.072L70.1828 141.817V238.423H17.7772V161.072ZM232.275 249.393H232.274H7.72574V246.148H10.0519H70.1833H77.909H86.5837H153.417H162.092H169.818H229.949H232.275V249.393H232.275Z",
    fill: "#0079FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.867 88.9609C110.896 88.9609 103.598 96.2593 103.598 105.23V128.836H136.137V105.23C136.137 96.2593 128.839 88.9609 119.867 88.9609ZM128.411 121.11H111.324V105.23C111.324 100.519 115.156 96.6867 119.867 96.6867C124.579 96.6867 128.411 100.519 128.411 105.23V121.11H128.411Z",
    fill: "#0079FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5585 146.516H84.082V154.241H91.5585V146.516Z",
    fill: "#0079FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.777 146.516H100.301V154.241H107.777V146.516Z",
    fill: "#0079FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.004 146.516H116.527V154.241H124.004V146.516Z",
    fill: "#0079FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140.23 146.516H132.754V154.241H140.23V146.516Z",
    fill: "#0079FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M156.457 146.516H148.98V154.241H156.457V146.516Z",
    fill: "#0079FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch);
export default __webpack_public_path__ + "static/media/Church.b6462029b2c1ec6c09786f1c4be37bae.svg";
export { ForwardRef as ReactComponent };